import { calendarConstants } from "../../_constants";

const initialState = {};

export const check_google_calendar_linked_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarConstants.CHECK_GOOGLE_CALENDAR_LINKED_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarConstants.CHECK_GOOGLE_CALENDAR_LINKED_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarLinkedData: action.payload,
      };
    case calendarConstants.CHECK_GOOGLE_CALENDAR_LINKED_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const store_google_calendar_token_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarConstants.STORE_GOOGLE_CALENDAR_TOKEN_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarConstants.STORE_GOOGLE_CALENDAR_TOKEN_ACTION_SUCCESS:
      return {
        type: "alert-success",
        storeTokenData: action.payload,
      };
    case calendarConstants.STORE_GOOGLE_CALENDAR_TOKEN_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_google_calendar_event_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarConstants.GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarConstants.GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        googleCalendarEventListsData: action.payload,
      };
    case calendarConstants.GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_calendar_scheduled_event_lists_timings_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarScheduledEventListsData: action.payload,
      };
    case calendarConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
